import { inject, Pipe, PipeTransform } from '@angular/core';
import { map, Observable, take } from 'rxjs';

import { BrowserLanguageService } from '@plugins/client/translate/services';

import {
  countTransform,
  DEFAULT_DECIMAL_PLACES,
} from './abbreviate-number.pipe.utils';
@Pipe({
  name: 'abbreviateNum',
  standalone: true,
})
export class AbbreviateNumberPipe implements PipeTransform {
  private languageService = inject(BrowserLanguageService);

  handleTransform = countTransform;
  transform(
    count: number,
    decimalPlaces = DEFAULT_DECIMAL_PLACES,
  ): Observable<string> {
    return this.languageService.locale$.pipe(
      take(1),
      map((locale) => this.handleTransform(count, locale, decimalPlaces)),
    );
  }
}
